import React from 'react';
import {connect} from 'react-redux';
import _ from "lodash";
import {withRouter} from "react-router-dom";

import withStyles from '@material-ui/core/styles/withStyles';
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Skeleton from "@material-ui/lab/Skeleton";

import {customerWithoutGroupMessage} from "../../../ReportGroupCreation/constants";
import GroupListItem from './components/GroupListItem'
import {PrimaryButton} from "../../../../components/Buttons";
import {ROUTES} from "../../../../routes";
import {executeIfPathExist, getInvestmentDynamicPath} from "../../../InvestmentPlatform/utils";
import EditGroupNameModal from "../../../DashboardSettings/components/EditGroupNameModal";
import {GroupResource} from "../../../../utils/api";
import withNotification from "../../../../components/NotificationProvider";
import DeleteGroupModal from "../../../ReportGroupCreation/components/DeleteGroupModal";
import {displayErrorSnackBar} from "../../../../components/SnackbarProvider/actions";
import CustomerFilteringPanel from "../../../../components/CustomersSelectorProviderNew/components/CustomerFilteringPanel";
import {getSearchCustomerType} from "../../../../components/FilteringPanel/components/ListSelector/constants";
import {SORTING_TYPES} from "../../../../components/FilteringPanel/components/SortingFilter/constants";
import {getErrorMessage, UserUtils} from '../../../../utils/utils';
import {filterGroups, sortGroups} from '../../../DashboardSettings/utils';
import {addCustomersToStore} from "../../../../components/CustomersDataProvider/actions";
import {setReportingGroups} from "../../actions";
import FilterInput from "../../../DocumentCenter/components/FilterInput/FilterInput";
import {buildSelectedValue} from "../../../TransactionsMonitoring/utils";
import WarningTooltip from "../../../../components/WarningTooltip";
import GroupFilterResult from "./components/GroupFilterResults";

import styles from './styles';


const mapStateToProps = (state) => ({
  initialGroups: state.get('reporting').toJS().groups,
  groupsLoading: state.get('reporting').toJS().groupsLoading,
  guideTourGroups: state.get('reporting').toJS().guideTourGroups,
  investmentPlatform: state.get('investmentPlatform').toJS(),
  auth: state.get('auth').toJS(),
  customers: state.get('customersDataProvider').toJS().customers,
  storeCustomersErrors: state.get('customersDataProvider').toJS().errors,
});

export const additionalFiltersRender = (customers) => ({filters, onChange, classes}) => {

  const options = React.useMemo(() => {
    return (customers || []).map(c => ({name: `${c.customer_full_name} (${c.customer_id})`, value: c.customer_id}))
  }, []);

  const selectedCustomers = filters.customers || [];
  const isAllSelected = options.length === selectedCustomers.length;

  return (
    <Grid item xs={12} md={4}>
      <FilterInput
        withDefault={false}
        label={<div style={{height: '1em'}}>Kunden<WarningTooltip title={'Suchen Sie hier nach Kunden innerhalb Ihrer Gruppen'} /></div>}
        onChange={(e, val) => onChange('customers')(val)}
        value={selectedCustomers}
        options={options}
        customclasses={{autocompleteInput: classes.autocompleteInput, label: classes.autoCompleteLabel}}
        multiple
        renderTags={() => {}}
        renderInput={(params) => (
          <div className={classes.inputContainer}>
            <TextField
              placeholder={buildSelectedValue(isAllSelected, selectedCustomers.map(o => ({ label: o.name })), 'Bitte geben Sie mindestens vier Zeichen ein')}
              variant="outlined"
              className={!_.isEmpty(selectedCustomers) && classes.darkPlaceholder}
              {...params}
            />
          </div>
        )}
        renderOption={(option, {selected}) => (
          <>
            <Checkbox color={'primary'} checked={selected} disableRipple disableTouchRipple />
            <div>{option.name}</div>
          </>
        )}
      />
    </Grid>
  )
};

const CustomerGroupList = (props) => {

  const {
    classes,
    initialGroups,
    guideTourGroups,
    groupsLoading,
    auth
  } = props;

  // TODO: do we really need duplicate groups in local state and redux
  const [groups, setGroups] = React.useState([]);

  const withoutGroupLoading = React.useMemo(() => {
    return groupsLoading || _.some(groups, g => !_.isNil(g.dynamic_filters) && !g.customers_loaded);
  }, [groupsLoading, groups]);

  const withoutGroupCount = React.useMemo(() => {
    // Use memo to get number of customers without groups
    return !_.isEmpty(props.customers)
      ? props.customers.filter(c => _.isEmpty(c.groups)).length
      : undefined;
  }, [props.customers]);

  React.useEffect(() => {
    setGroups([...initialGroups])
  }, [initialGroups]);

  const [filters, setFilters] = React.useState({
    search: '',
    first_letter: '',
    sortingType: SORTING_TYPES.NAME_ASC,
    triggerFilter: true
  });

  const [filteredGroups, setFilteredGroups] = React.useState([]);

  React.useEffect(() => {
    handleFilterGroups();
  }, [groups]);

  React.useEffect(() => {
    if (filters.triggerFilter) {
      handleFilterGroups();
    }
  }, [filters.triggerFilter]);

  const onNewGroupButtonClick = () => {
    executeIfPathExist(props.investmentPlatform.routes, 'SERIES_REPORTING', (dynamicPath) => {
      const path = '/' + getInvestmentDynamicPath() + dynamicPath + ROUTES.BROKER.GROUP_CREATE.newDesignPath;
      props.history.push(path);
    })
  }

  const[editNameGroup, setEditNameGroup] = React.useState()

  const handleEditNameClicked = (group) => {
    setEditNameGroup(group)
  };

  const updateGroupCustomers = (group, customers) => {
    // as group is object in groups we could update it and call dispatch to trigger groups update
    group.customers = customers;
    group.customers_loaded = true;
    props.dispatch(setReportingGroups(groups));

    // update customers in store
    const byCustomerId = _.keyBy(props.customers, 'customer_id');
    customers.forEach(c => {
      const customerData = byCustomerId[c.customer_id];
      if(customerData){
        customerData.groups.push(group.id);
      }
    });
    props.dispatch(addCustomersToStore(props.customers))
  };

  const handleEditNameClose = () => {
    setEditNameGroup(undefined)
  };

  const handleDeleteGroupClose = () => {
    setGroupToDelete({});
    setDeletingStatus(false);
  };

  async function handleEditNameSave(groupToUpdate, newGroupName) {
    try {
      await GroupResource.at(`${groupToUpdate.id}/`).patch({name: newGroupName});

      handleEditNameClose()
      props.displayNotification('success', `Ihre Gruppe "${newGroupName}" wurde gespeichert.`)

      // set group name
      let groupsWithUpdated = [...groups].map(g => {
        if(g.id == groupToUpdate.id){
          g.name = newGroupName
        }
        return g
      })

      setGroups(groupsWithUpdated)
      props.dispatch(setReportingGroups(groupsWithUpdated))

    } catch (error) {

      let errorMessage = 'Error!';
      if (_.isObject(error)  && 'name' in error) {
        errorMessage = error.name[0];
      }

      props.displayNotification('error', errorMessage);
    }
  }

  const [isDeleting, setDeletingStatus] = React.useState(false);
  const [groupToDelete, setGroupToDelete] = React.useState({});

  const removeGroupFromStorageCustomers = (customersToUpd) => {
    // Function to update groups key of customers in storage if group was deleted

    const storeCustomers = props.customers;
    // if customers are loaded without any errors
    if(!props.storeCustomersErrors && storeCustomers){
      // loop over list of all customers
      for (let index = 0; index < storeCustomers.length; index++) {
        // check if customer is in list of customers that needs to be updated
        customersToUpd.forEach(customerData => {
          if (storeCustomers[index].id == customerData.id) {
            // filter group that was deleted
            storeCustomers[index].groups = storeCustomers[index].groups.filter(g => g != groupToDelete.id)
          }
        });
      }

      // update customers in store
      props.dispatch(addCustomersToStore(storeCustomers))
    }
  }

  const deleteGroup = async () => {
    setDeletingStatus(true);
    try {
      await GroupResource.at(`${groupToDelete.id}/`).delete();

      let groupsWithoutDeleted = _.filter([...groups], group => group.id !== groupToDelete.id);
      setGroups(groupsWithoutDeleted);
      props.dispatch(setReportingGroups(groupsWithoutDeleted));
      removeGroupFromStorageCustomers(groupToDelete.customers);

      props.displayNotification('success', `Gruppe "${groupToDelete.name}" wurde erfolgreich gelöscht.`);

    } catch (error) {
      props.dispatch(displayErrorSnackBar(getErrorMessage(error)));
    }

    handleDeleteGroupClose();
  };

  const renderList = () => {
    if (guideTourGroups && guideTourGroups.length) {
      return guideTourGroups.map((group) => {
        return (
          <GroupListItem key={group.id} group={group} />
        )
      })
    }

    if (groupsLoading) {
      return (
        <>
          <GroupListItem group={{}} loading={true} />
          <GroupListItem group={{}} loading={true} />
          <GroupListItem group={{}} loading={true} />
        </>
      )
    }

    return [...filteredGroups || []].map((group) => {
      return (
        <GroupListItem
          key={group.id}
          group={group}
          onEditNameClick={handleEditNameClicked}
          setGroupToDelete={setGroupToDelete}
          isDeleting={isDeleting}
          defaultExpanded={!_.isEmpty(filters.customers)}
          updateGroupCustomers={updateGroupCustomers}
        />
      )
    })
  };

  const handleSearchByLetter = (letter) => {
    let searchValue = letter ? letter.trim() : ''
    setFilters({
      ...filters,
      first_letter: searchValue,
      search: '',
      triggerFilter: true
    });
  };

  const handleSearchClicked = (value, additionalFiltersValues) => {
    let searchValue = value ? value.trim() : '';
    setFilters({
      ...filters,
      ...additionalFiltersValues,
      first_letter: '',
      search: searchValue,
      triggerFilter: true
    });
  };

  const handleFilterGroups = () => {

    if (Object.entries(filters).length !== 0) {
      let groupsJoined = [].concat.apply([], groups || []);
      const selectedCustomers = (filters.customers || []);
      let filtered = [...filterGroups(groupsJoined, {...filters, customers: selectedCustomers.map(c => c.value)})];

      filtered = sortGroups(filtered, filters.sortingType);

      setFilters(({
        ...filters,
        triggerFilter: false
      }));

      setFilteredGroups(filtered);
    }
  };

  const resetFilters = () => handleSearchClicked('', {customers: []});


  return (
    <div className={classes.container}>

      <div className={classes.listHeader}>
        IHRE KUNDENGRUPPEN
        {withoutGroupLoading ? (
          <span className={classes.withoutGroupCount}>
            <Skeleton width={400} style={{display: 'inline-block'}} />
          </span>
        ) : (
          withoutGroupCount >= 0 && <span className={classes.withoutGroupCount}>{customerWithoutGroupMessage(withoutGroupCount)}</span>
        )}
      </div>

      <div className={classes.addGroupSection}>
        {(!groupsLoading && groups && groups.length === 0 && !(guideTourGroups && guideTourGroups.length)) && (
          <p>Sie haben noch keine Kundengruppe erstellt.</p>
        )}
        {withoutGroupLoading ? (
          <Skeleton height={36} width={200} variant={"rect"} />
        ) : (
          <PrimaryButton
            id='report-settings-add-group-btn-tour-element'
            text='Kunden selektieren'  // Neue Gruppe erstellen
            onButtonClick={onNewGroupButtonClick}
            icon={<AddIcon />}
            customClasses={{root: 'pulse-animation'}}
          />
        )}
      </div>
      <div className={classes.filterHeader}>
        Gruppenübersicht
      </div>
      <CustomerFilteringPanel
        customerType={getSearchCustomerType(auth).value}
        defaultSearchValue={''}
        handleSearchByLetter={handleSearchByLetter}
        handleSearchClicked={handleSearchClicked}
        isChief={UserUtils.isChief(auth)}
        user={auth.user}
        useGroupSearchTooltip
        additionalFiltersRender={additionalFiltersRender(props.customers)}
        loading={groupsLoading}
        resetFilters={resetFilters}
      />
      <GroupFilterResult count={filteredGroups.length} filters={filters} />
      {renderList()}

      <EditGroupNameModal
        group={editNameGroup}
        open={!!editNameGroup}
        onSaveClick={handleEditNameSave}
        onModalClose={handleEditNameClose}
      />

      <DeleteGroupModal
        open={!_.isEmpty(groupToDelete)}
        handleClose={handleDeleteGroupClose}
        handleDeleteClick={deleteGroup}
        isDeleting={isDeleting}
        groupName={groupToDelete.name}
      />
    </div>
  )
};


export default withStyles(styles)(
  connect(mapStateToProps)(withNotification(withRouter(CustomerGroupList)))
);